//https://ageofempires.fandom.com/wiki/Scholar
//Converted using ChatGPT
function T(n, t0, r) {
	return Math.floor((t0 - t0 / 15) * Math.pow(r, n) + t0 / 15)
}

export function DelhiScholar({ scholarCount }) {
	const r = 0.8780845 //Vlaue
	return (
		<div
			className="flex flex-row w-[84px] h-[40px] justify-center border-solid border"
			style={{
				backgroundImage: `url(/liveGameIcons/BACKGROUND.png)`,
				borderColor: 'var(--main-color)',
			}}
		>
			<div className="flex flex-col text-right gap-1">
				<div className="h-4 text-white">{parseInt(scholarCount)}</div>
				<div className="h-4 text-[#b1b1b1] italic text-xs">
					{((T(scholarCount, 1080, r) / 1080) * 100).toFixed(0)}%
				</div>
			</div>
			<img
				className="h-10 -mr-2"
				src="/liveGameIcons/unique/scholar_research.png"
				alt=""
			/>
		</div>
	)
}
